"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import TopBarStore from 'Stores/TopBarStore';
import * as actions from 'Actions/TopBarActions';
import { changeTheme, sideDrawerOpen, sideDrawerChangeAnchor, loadForm } from 'Actions/ApplicationActions';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import WbIncandescent from '@material-ui/icons/WbIncandescent';
import WbIncandescentOutlined from '@material-ui/icons/WbIncandescentOutlined';
import FormatTextdirectionLToR from '@material-ui/icons/FormatTextdirectionLToR';
import FormatTextdirectionRToL from '@material-ui/icons/FormatTextdirectionRToL';
import classNames from 'classnames';
import { logout } from "Actions/ApplicationActions";
import { Messages } from "Messages";
import ApplicationStore from "Stores/ApplicationStore";
import { System } from "Constants/objects";
import { getSystemParam } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1
    },
    flex: {
      flex: 1,
      fontSize: '1.2rem'
    },
    appBar: {
      position: 'absolute' // transition: theme.transitions.create(['margin', 'width'], {
      //     easing: theme.transitions.easing.sharp,
      //     duration: theme.transitions.duration.leavingScreen,
      // }),

    },
    appBarShift: {// transition: theme.transitions.create(['margin', 'width'], {
      //     easing: theme.transitions.easing.easeOut,
      //     duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    toolBar: {
      height: '45px',
      minHeight: '45px',
      paddingRight: '24px'
    },
    menuButton: {
      marginLeft: 12,
      marginRight: 20
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px'
    },
    hide: {
      display: 'none'
    },
    typoRoot: {
      lineHeight: '1.4em'
    },
    itemRoot: {
      paddingBottom: '8px',
      paddingTop: '8px'
    },
    iconStyle: {
      width: '38px',
      height: '38px',
      padding: 0
    }
  };
};

var TopBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TopBar, _React$Component);

  function TopBar(props) {
    var _this;

    _classCallCheck(this, TopBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TopBar).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = TopBarStore.getList();
    return _this;
  }

  _createClass(TopBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      TopBarStore.addChangeListener(this._onChange);
      setTimeout(function () {
        return actions.topBarSetDynToolBar(_this2.dynamicToolbar);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TopBarStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      this.setState(TopBarStore.getList());
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(event) {
      actions.clickUserMenu(event.currentTarget);
    }
  }, {
    key: "handleMenuClose",
    value: function handleMenuClose() {
      actions.closeUserMenu();
    }
  }, {
    key: "handleLightClick",
    value: function handleLightClick() {
      changeTheme(ApplicationStore.theme === System.THEME.LIGHT ? System.THEME.BLUE : System.THEME.LIGHT);
    }
  }, {
    key: "handleChangeDrawerAnchorClick",
    value: function handleChangeDrawerAnchorClick() {
      sideDrawerChangeAnchor(this.props.drawerAnchor === System.DIRECTION.LEFT ? System.DIRECTION.RIGHT : System.DIRECTION.LEFT);
    }
  }, {
    key: "handleDrawerOpen",
    value: function handleDrawerOpen() {
      sideDrawerOpen();
    }
  }, {
    key: "doLogout",
    value: function doLogout() {
      logout();
    }
  }, {
    key: "showUserSettings",
    value: function showUserSettings() {
      actions.closeUserMenu();
      loadForm({
        viewMode: System.VIEW_MODE.MODAL,
        type: System.FORM_TYPE.SETTINGS_MODAL
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          drawerWidth = _this$props.drawerWidth,
          drawerAnchor = _this$props.drawerAnchor,
          drawerOpen = _this$props.drawerOpen;
      var _this$state = this.state,
          anchorMenuEl = _this$state.anchorMenuEl,
          title = _this$state.title,
          dynamicToolbarContent = _this$state.dynamicToolbarContent;
      var menuOpen = Boolean(anchorMenuEl);
      var appBarShiftStyle = {
        width: drawerOpen ? "calc(100% - ".concat(drawerWidth, "px)") : '100%'
      };

      if (drawerAnchor === 'left') {
        appBarShiftStyle.marginLeft = Number(drawerOpen) && drawerWidth;
      } else {
        appBarShiftStyle.marginRight = Number(drawerOpen) && drawerWidth;
      }

      return React.createElement(AppBar, {
        className: classNames(classes.appBar, _defineProperty({}, classes.appBarShift, drawerOpen)),
        style: appBarShiftStyle
      }, React.createElement(Toolbar, {
        className: classNames(classes.toolBar),
        disableGutters: !drawerOpen
      }, React.createElement(IconButton, {
        color: "inherit",
        "aria-label": "open drawer",
        onClick: this.handleDrawerOpen,
        className: classNames(classes.iconStyle, classes.menuButton, drawerOpen && classes.hide)
      }, React.createElement(MenuIcon, null)), React.createElement(Typography, {
        variant: "h6",
        color: "inherit",
        className: classes.flex
      }, title || getSystemParam('MainForm', 'TopBarTitle')), React.createElement("div", {
        id: "dynamic-toolbar",
        ref: function ref(r) {
          return _this3.dynamicToolbar = r;
        }
      }, React.createElement("div", {
        className: "dynamic-toolbar-content"
      }, dynamicToolbarContent)), React.createElement("div", null, React.createElement(IconButton, {
        className: classNames(classes.iconStyle),
        onClick: this.handleLightClick,
        color: "inherit"
      }, ApplicationStore.theme !== System.THEME.LIGHT ? React.createElement(WbIncandescent, null) : React.createElement(WbIncandescentOutlined, null)), React.createElement(IconButton, {
        className: classNames(classes.iconStyle),
        onClick: this.handleChangeDrawerAnchorClick.bind(this),
        color: "inherit"
      }, drawerAnchor === System.DIRECTION.LEFT ? React.createElement(FormatTextdirectionRToL, null) : React.createElement(FormatTextdirectionLToR, null)), React.createElement(IconButton, {
        className: classNames(classes.iconStyle),
        "aria-owns": menuOpen ? 'menu-appbar' : null,
        "aria-haspopup": "true",
        onClick: this.handleMenuClick,
        color: "inherit"
      }, React.createElement(AccountCircle, null)), React.createElement(Menu, {
        id: "menu-appbar",
        anchorEl: anchorMenuEl,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        open: menuOpen || false,
        onClose: this.handleMenuClose
      }, React.createElement(MenuItem, {
        onClick: this.showUserSettings,
        classes: {
          root: classes.itemRoot
        }
      }, React.createElement(Typography, {
        variant: "subtitle2",
        classes: {
          root: classes.typoRoot
        }
      }, Messages.Controls.UserSettings)), React.createElement(MenuItem, {
        onClick: this.doLogout,
        classes: {
          root: classes.itemRoot
        }
      }, React.createElement(Typography, {
        variant: "subtitle2",
        classes: {
          root: classes.typoRoot
        }
      }, Messages.Controls.SingOut))))));
    }
  }]);

  return TopBar;
}(React.Component);

_defineProperty(TopBar, "propTypes", {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  drawerAnchor: PropTypes.string.isRequired,
  drawerOpen: PropTypes.bool.isRequired
});

export default withStyles(styles, {
  withTheme: true
})(TopBar);